import { Component } from 'shimmer'

import randomRange from '@/utils/Maths'

import {
  SphereGeometry,
  PlaneGeometry,
  // MeshNormalMaterial,
  MeshBasicMaterial,
  Color,
  Mesh
} from 'three'

export class Ball extends Component {
  constructor () {
    super()

    const geo = new SphereGeometry()
    // const mat = new MeshNormalMaterial()
    const mat = new MeshBasicMaterial({
      color: new Color(Math.random(), Math.random(), Math.random())
    })
    this.object = new Mesh(geo, mat)
    this.add(this.object)
  }

  set reflection (billboardReflection) {
    billboardReflection.create(this.object, { reflectionColorMultiplier: 1.25 })
  }
}